<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>

export default {
  name: 'App',
  methods: {
    resolveAfter10Seconds() {
      return new Promise(resolve => {
        setTimeout(() => {
            resolve().return('resolved');
        }, 1000);
    });
   }
  }
}
</script>

<style lang="sass">
@import "@/styles/main"
</style>
